/** Acesso tipado às variáveis de ambiente públicas (prefixo VITE_). */

const rawBaseUrl = import.meta.env.VITE_API_BASE_URL

export const env = {
  /** URL base da API. Em dev é "/api" (proxy do Vite). */
  apiBaseUrl: (rawBaseUrl && rawBaseUrl.trim()) || '/api',
  isDev: import.meta.env.DEV,
  isProd: import.meta.env.PROD,
} as const
